import buildUrl from "../utils/buildUrl";
import { baseUrl } from "./baseUrl";

export const getReportRoute = (reportId: number) =>
  buildUrl({ url: `${baseUrl}/reports-api/reports/${reportId}/generate` });

export const getReportsCatalogRoute = () =>
  buildUrl({ url: `${baseUrl}/reports-api/reports-catalog` });
